export default {
    previewObserver: null,
    preview: null,
    hoverPreview: null,

    setPreview(imageObject, element, isLeaving = false) {
        clearTimeout(this.hoverPreview);
        this.hoverPreview = null;

        this.preview.innerHTML = null;
        this.preview.style.display = 'none';

        if (!imageObject || isLeaving) {
            return;
        }

        this.hoverPreview = setTimeout(() => this.showPreview(imageObject, element), 300);
    },

    setPreviewSize(image) {
        const horizontal = image.offsetWidth > image.offsetHeight

        const maxWidth = Math.min(window.innerWidth * .4, 700);
        const maxHeight = Math.min(window.innerHeight * .6, 600);

        if (horizontal) {
            const heightPercentage = Math.ceil(image.offsetHeight * 100 / image.offsetWidth);

            const imageHeight = maxWidth * heightPercentage / 100;
            const imageWidth = imageHeight / heightPercentage * 100;

            this.preview.style.width = `${maxWidth}px`;
            this.preview.style.height = `${imageHeight}px`;

            this.preview.style.setProperty('--image-height', this.preview.style.height);
            this.preview.style.setProperty('--image-width', `${imageWidth}px`);
        } else {
            const widthPercentage = Math.ceil(image.offsetWidth * 100 / image.offsetHeight);

            const imageWidth = maxHeight * widthPercentage / 100;
            const imageHeight = imageWidth / widthPercentage * 100;

            this.preview.style.height = `${maxHeight}px`;
            this.preview.style.width = `${imageWidth}px`;

            this.preview.style.setProperty('--image-width', this.preview.style.width);
            this.preview.style.setProperty('--image-height', `${imageHeight}px`);
        }

        this.preview.classList.remove('hidden');
    },

    checkPreviewPosition(box) {
        const options = {root: this.container};

        if (this.previewObserver) {
            this.previewObserver.disconnect();
            this.previewObserver = null;
        }

        this.previewObserver = new IntersectionObserver(
            ([{boundingClientRect}]) => {
                const top = boundingClientRect.top + (boundingClientRect.height / 2);
                const left = window.innerWidth * .4 > boundingClientRect.left;

                const maxTop = `calc(${window.innerHeight - 5}px - var(--image-height))`;
                const imageWidth = left ? `+ ${boundingClientRect.width}px` : '- var(--image-width)';

                const previewTop = `calc(${top}px - calc(var(--image-height) / 2))`;
                const previewLeft = `calc(${boundingClientRect.left}px ${imageWidth})`;

                this.preview.style.left = `max(5px, ${previewLeft})`;
                this.preview.style.top = `max(5px, min(${previewTop}, ${maxTop}))`;

                if (this.preview.childElementCount) {
                    this.preview.style.display = 'block';
                }
            },
            options
        );

        this.previewObserver.observe(box);
    },

    observerPreview() {
        const observer = new MutationObserver(mutationList =>
            mutationList.forEach(mutation => {
                    if (document.getElementById(this.$el.getAttribute('id')) === null) {
                        this.setPreview(null);
                        observer.disconnect();
                    }
                }
            ));

        observer.observe(this.preview, {attributes: true, childList: true, subTree: true});
    },

    movePreviewToOutside() {
        if (document.querySelectorAll('.preview.moved').length) {
            this.preview = document.querySelector('.preview.moved');
            return;
        }

        document.querySelectorAll('.preview.moved').forEach((element) => {
            element.remove();
        });

        this.preview.classList.add('moved');

        document.body.before(this.preview);
    },

    isMobileDevice() {
        const userAgentCheck = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent);
        const touchCheck = window.matchMedia("(pointer: coarse)").matches;

        return userAgentCheck || touchCheck;
    },

    showPreview(imageObject, element) {
        if (!element || !document.body.contains(element)) {
            return;
        }

        if (this.isMobileDevice() || window.innerWidth < 768) {
            return;
        }

        this.preview.style.background = `#EBEBEB url('${_.get(imageObject, 'thumb')}') no-repeat center / contain`;
        this.checkPreviewPosition(element);

        const image = document.createElement("img");
        const title = document.createElement("span");

        if (element.style.backgroundImage == 'url("undefined")') {
            return;
        }

        image.alt = _.get(imageObject, 'name');
        image.src = _.get(imageObject, 'preview');
        image.classList.add("object-contain", "h-full", 'm-auto');

        title.innerText = _.get(imageObject, 'name');

        title.classList.value = `
            bottom-0 left-0 absolute bg-black bg-opacity-50 text-white p-1 text-xs
            overflow-hidden ellipsis w-full
        `;

        this.setPreviewSize(element);

        this.$nextTick(() => {
            this.checkPreviewPosition(element);
        });

        this.movePreviewToOutside();
        this.preview.appendChild(image);
        this.preview.appendChild(title);
    }
}
